import { useState, useEffect } from "react";
import axios from "axios"


//Cadastrar Equipamentos
import GerenciarTipoChamado from './components/Gerenciar-tipo-chamado.js';
import GerenciarSubTipoChamado from './components/Gerenciar-sub-tipo-chamado.js';
import GerenciarItemSubTipoChamado from './components/Gerenciar-item-sub-tipo-chamado.js';
import ListaTiposEquipamento from './components/Grid-tipos-problemas.js';



import GlobalStyle from "../../../../styles/global-new.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";


const Div = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
      border-radius:15px;
`;

const Container = styled.div`
  width: 89.2vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;



  div{
    width: 89.3vw;
  
  }
`;





function Usuarios({ urlApi }) {

  const token = localStorage.getItem('token');




  //------------------------------------------TIPO/SUBTIPO MATERIAL-----------------------------------------------------------------//
  const [tipoChamado, setTipoChamado] = useState([]);
  const [subTipoChamado, setSubTipoChamado] = useState([]);
  const [itemSubTipoChamado, setItemSubTipoChamado] = useState([]);
  const [atualizaTipos, setAtualizaTipos] = useState(false);




  const getTipo = async () => {
    try {
      const res = await axios.get(`${urlApi}central-ti/tipo-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTipoChamado(res.data);

      const res1 = await axios.get(`${urlApi}central-ti/sub-tipo-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSubTipoChamado(res1.data);

      const res2 = await axios.get(`${urlApi}central-ti/item-sub-tipo-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setItemSubTipoChamado(res2.data);

      setAtualizaTipos(false);
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };


  useEffect(() => {
    getTipo();
  }, [atualizaTipos]);





  //---------------------------------------MODAL GERENCIAR TIPO CHAMADO---------------------------------------------------//

  const [isModalOpenGerenciarTipoChamado, setIsModalOpenGerenciarTipoChamado] = useState(false);
  const modalVerTiposChamado = () => {
    setIsModalOpenGerenciarTipoChamado(!isModalOpenGerenciarTipoChamado);

  };

  //---------------------------------------MODAL GERENCIAR SUBTIPO CHAMADO---------------------------------------------------//

  const [isModalOpenGerenciarSubTipoChamado, setIsModalOpenGerenciarSubTipoChamado] = useState(false);
  const modalVerSubTiposChamado = () => {
    setIsModalOpenGerenciarSubTipoChamado(!isModalOpenGerenciarSubTipoChamado);

  };

  //---------------------------------------MODAL GERENCIAR ITEM SUBTIPO CHAMADO---------------------------------------------------//

  const [isModalOpenGerenciarItemSubTipoChamado, setIsModalOpenGerenciarItemSubTipoChamado] = useState(false);
  const modalVerItemSubTiposChamado = () => {
    setIsModalOpenGerenciarItemSubTipoChamado(!isModalOpenGerenciarItemSubTipoChamado);

  };



  const [painelVisivel, setPainelVisivel] = useState('TIPO');

  const mostrarPainelTipo = () => setPainelVisivel('TIPO');
  const mostrarPainelSubTipo = () => setPainelVisivel('SUBTIPO');
  const mostrarPainelItemSubTipo = () => setPainelVisivel('ITEMSUBTIPO');

  return (
    <>


      <Div>
        <Container>
          <ListaTiposEquipamento
            onAbrirTipo={mostrarPainelTipo}
            onAbrirSubTipo={mostrarPainelSubTipo}
            onAbrirItemSubTipo={mostrarPainelItemSubTipo}
          />

          {painelVisivel === 'TIPO' && (
            <GerenciarTipoChamado
              urlApi={urlApi}
              tipoChamado={tipoChamado}
              setAtualizaTipos={setAtualizaTipos}
            />
          )}

          {painelVisivel === 'SUBTIPO' && (
            <GerenciarSubTipoChamado
              urlApi={urlApi}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              setAtualizaTipos={setAtualizaTipos}
            />
          )}

          {painelVisivel === 'ITEMSUBTIPO' && (
            <GerenciarItemSubTipoChamado
              urlApi={urlApi}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              setAtualizaTipos={setAtualizaTipos}
            />
          )}

        </Container>

        <div>
          <ToastContainer
            autoClose={2500}
            position={toast.POSITION.BOTTOM_LEFT}
            style={{ width: '400px', fontSize: '22px' }}
          />

        </div>
      </Div>

      <GlobalStyle />
    </>
  );
}

export default Usuarios;
